import React from 'react';
import { Typography, Descriptions, Space, Tooltip } from 'antd';

const { Paragraph } = Typography;

const Zja = (props) => {
  const { jname, onuTest} = props;
  const bangm = jname;

  const items = [
    {
      label: '用户账号',
      children: <Tooltip title={`商户编号：${bangm.uid}`} color='blue'><Space onClick={() => { onuTest('chuna_psw') }}>{bangm.u_name}</Space></Tooltip>,
    },
    {
      label: '商户编号',
      children: <Paragraph copyable>{bangm.uid}</Paragraph>,
    },
    {
      label: '到期时间',
      children: <Space onClick={() => { onuTest('xufei') }}>{bangm.dq_time}</Space>,
    },
    {
      label: '联系电话',
      children: bangm.u_phone,
    },
    {
      label: '电子邮箱',
      children: <Tooltip title="用于接收安全验证或者订单详情" color='blue'><Space onClick={() => { onuTest('setemail') }}>{bangm.hzlb}</Space></Tooltip>,
    },
    {
      label: <Tooltip title="点击进行在线充值" color='blue'>钱包余额</Tooltip>,
      children: <Tooltip title="点击进行在线充值" color='blue'><Space onClick={() => { onuTest('chongzhi') }}>{bangm.u_qb}</Space></Tooltip>,
    },
    {
      label: '营销余额',
      children: <span>{bangm.yx_ye}</span>,
    },
    {
      label: '认证余次',
      children: <Tooltip title="企业认证消耗，点击进行兑换" color='blue'><Space onClick={() => { onuTest('renzheng') }}>{bangm.rz_s}</Space></Tooltip>,
    },
    {
      label: '胜券余额',
      children: <Tooltip title='仅用于数据批次续费，修复使用' color='blue' onClick={() => { onuTest('shengquandh') }} >{bangm.dq_ye}</Tooltip>,
    },


    {
      label: '数据总量',
      children: <Tooltip title={'产品数量：' + bangm.hzlb} color='blue'>{bangm.hznum}</Tooltip>,
    },
    {
      label: '推广收益',
      children: <Space onClick={() => { onuTest('shouyitixian') }}>{bangm.tg_sy}</Space>,
    },
    {
      label: '推广链接',
      children: <Paragraph copyable={{ text: 'http://www.ddspp.com/?t=' + bangm.uid }}></Paragraph>,
    },


  ];

  return (<>
    {true && <Descriptions items={items} />}
  </>);
};
export { Zja }